<!--
 * @Version: 1.0
 * @Autor: wenruihuan
 * @Date: 2022-04-01 00:42:30
 * @LastEditors: myname
 * @LastEditTime: 2022-04-04 01:50:05
-->
<template>
  <div
    class="common-button"
    :class="isBackground ? 'common-button-bg' : 'common-button-no-bg'"
    @click="btnClick"
    :style="{
      width: buttonStyle.width,
      color: buttonStyle.textColor,
      height: buttonStyle.height,
      lineHeight: buttonStyle.height
    }"
  >
    {{ text }}
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data() {
    return {};
  },
  methods: {
    btnClick() {
      this.$emit("click");
    },
  },
  props: {
    isBackground: {
      default: true,
      type: Boolean
    },
    buttonStyle: Object,
    text: String,
    width: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.common-button {
  /* background: url("../../assets/images/btn_icon1.png") no-repeat; */
  background: #235378;
  background-size: 60% 60%;
  border-radius: 0.1406rem;
  font-size: 13px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
  transition: 0.1s;
}
.common-button-bg{
  background: #235378;
}
.common-button-no-bg{
  background: none;
  color: #000 !important;
}
</style>
